export const INITIATE_GET_DASHBOARD_DATA = "INITIATE_GET_DASHBOARD_DATA";
export const GET_DASHBOARD_DATA_SUCCESS = "GET_DASHBOARD_DATA_SUCCESS";
export const GET_DASHBOARD_DATA_FAIL = "GET_DASHBOARD_DATA_FAIL";

export const SET_PENDING_TRANSFER_TYPE = "SET_PENDING_TRANSFER_TYPE";

// view introduction action types
export const INTIATE_VIEW_INTRODUCTION_DATA = "INTIATE_VIEW_INTRODUCTION_DATA";
export const SET_VIEW_INTRODUCTION_DATA = "SET_VIEW_INTRODUCTION_DATA";
export const SET_VIEW_INTRODUCTION_DATA_FAIL =
  "SET_VIEW_INTRODUCTION_DATA_FAIL";
export const SET_SELECTED_INTRODUCTION = "SET_SELECTED_INTRODUCTION";

export const INITIATE_VIEW_INTRODUCTION_REMARKS_DATA =
  "INITIATE_VIEW_INTRODUCTION_REMARKS_DATA";
export const SET_VIEW_INTRODUCTION_REMARKS_DATA =
  "SET_VIEW_INTRODUCTION_REMARKS_DATA";
export const SET_VIEW_INTRODUCTION_REMARKS_DATA_FAIL =
  "SET_VIEW_INTRODUCTION_REMARKS_DATA_FAIL";

export const SET_SELECTED_INTRODUCTION_FROM_SEARCH =
  "SET_SELECTED_INTRODUCTION_FROM_SEARCH";

// view friends action types
export const INITIATE_VIEW_FRIEND_DATA = "INTIATE_VIEW_FRIEND_DATA";
export const SET_VIEW_FRIEND_DATA = "SET_VIEW_FRIEND_DATA";
export const SET_VIEW_FRIEND_DATA_FAIL = "SET_VIEW_FRIEND_DATA_FAIL";
export const SET_SELECTED_FRIEND = "SET_SELECTED_FRIEND";

export const INITIATE_VIEW_FRIEND_REMARKS_DATA =
  "INITIATE_VIEW_FRIEND_REMARKS_DATA";
export const SET_VIEW_FRIEND_REMARKS_DATA = "SET_VIEW_FRIEND_REMARKS_DATA";
export const SET_VIEW_FRIEND_REMARKS_DATA_FAIL =
  "SET_VIEW_FRIEND_REMARKS_DATA_FAIL";
export const SET_FRIEND_SEARCH_QUERY = "SET_FRIEND_SEARCH_QUERY";
export const CLEAR_FRIEND_SEARCH_QUERY = "CLEAR_FRIEND_SEARCH_QUERY";

export const INITIATE_PENDING_TRANSFER_FRIEND_DATA =
  "INITIATE_PENDING_TRANSFER_FRIEND_DATA";
export const SET_PENDING_TRANSFER_FRIEND_DATA =
  "SET_PENDING_TRANSFER_FRIEND_DATA";
export const SET_PENDING_TRANSFER_FRIEND_DATA_FAIL =
  "SET_PENDING_TRANSFER_FRIEND_DATA_FAIL";
export const SET_SELECTED_PENDING_TRANSFER_FRIEND =
  "SET_SELECTED_PENDING_TRANSFER_FRIEND";
export const SET_SELECTED_PENDING_TRANSFER_FRIEND_REMARKS =
  "SET_SELECTED_PENDING_TRANSFER_FRIEND_REMARKS";

export const SET_SELECTED_FRIEND_FROM_SEARCH =
  "SET_SELECTED_FRIEND_FROM_SEARCH";

// view members action types
export const INITIATE_VIEW_MEMBER_DATA = "INITIATE_VIEW_MEMBER_DATA";
export const SET_VIEW_MEMBER_DATA = "SET_VIEW_MEMBER_DATA";
export const SET_VIEW_MEMBER_DATA_FAIL = "SET_VIEW_MEMBER_DATA_FAIL";
export const SET_SELECTED_MEMBER_TRANSFER = "SET_SELECTED_MEMBER_TRANSFER";
export const SET_VIEW_MEMBER_PAGE_DATA = "SET_VIEW_MEMBER_PAGE_DATA";

export const INITIATE_PENDING_TRANSFER_MEMBER_DATA =
  "INITIATE_PENDING_TRANSFER_MEMBER_DATA";
export const SET_PENDING_TRANSFER_MEMBER_DATA =
  "SET_PENDING_TRANSFER_FRIEND_DATA";
export const SET_PENDING_TRANSFER_MEMBER_DATA_FAIL =
  "SET_PENDING_TRANSFER_FRIEND_DATA_FAIL";
export const SET_PENDING_TRANSFER_MEMBER_PAGE_DATA =
  "SET_PENDING_TRANSFER_MEMBER_PAGE_DATA";
export const SET_SELECTED_PENDING_TRANSFER_MEMBER =
  "SET_SELECTED_PENDING_TRANSFER_MEMBER";
export const SET_SELECTED_PENDING_TRANSFER_MEMBER_REMARKS =
  "SET_SELECTED_PENDING_TRANSFER_MEMBER_REMARKS";

// view gohonzon action types
export const INITIATE_VIEW_GOHONZON_DATA = "INITIATE_VIEW_GOHONZON_DATA";
export const SEARCH_MEMBERS_FOR_APPLY_GOHONZON =
  "SEARCH_MEMBERS_FOR_APPLY_GOHONZON";
export const SEARCH_MEMBERS_FOR_RETURN_GOHONZON =
  "SEARCH_MEMBERS_FOR_RETURN_GOHONZON";
export const INITIATE_GOHONZON_APPLICATIONS = "INITIATE_GOHONZON_APPLICATIONS";
export const INITIATE_GOHONZON_TRACKING = "INITIATE_GOHONZON_TRACKING";

export const GET_ALL_GOHONZON_APPLICATIONS_BATCHES =
  "GET_ALL_GOHONZON_APPLICATIONS_BATCHES";
export const GET_ALL_APPLICATIONS_BY_BATCH = "GET_ALL_APPLICATIONS_BY_BATCH";
export const GET_ALL_HANDOVER_APPLICATIONS = "GET_ALL_HANDOVER_APPLICATIONS";
export const SET_MEMBERS_FOR_APPLY_GOHONZON = "SET_MEMBERS_FOR_APPLY_GOHONZON";
export const SET_MEMBERS_FOR_APPLY_GOHONZON_FAIL =
  "SET_MEMBERS_FOR_APPLY_GOHONZON_FAIL";
export const SET_MEMBER_FOR_APPLY_GOHONZON = "SET_MEMBER_FOR_APPLY_GOHONZON";
export const SET_MEMBER_FOR_TRACKING_GOHONZON =
  "SET_MEMBER_FOR_TRACKING_GOHONZON";

export const SET_GOHONZON_OTP = "SET_GOHONZON_OTP";
export const SET_RESET_GOHONZON_STATE = "SET_RESET_GOHONZON_STATE";
export const SET_GOHONZON_VERIFICATION_LIST = "SET_GOHONZON_VERIFICATION_LIST";
export const SET_GOHONZON_TYPE_FOR_APPLY = "SET_GOHONZON_TYPE_FOR_APPLY";
export const SET_VIEW_GOHONZON_DATA = "SET_VIEW_GOHONZON_DATA";
export const SET_VIEW_GOHONZON_DATA_FAIL = "SET_VIEW_GOHONZON_DATA_FAIL";
export const SET_GOHONZON_SEARCH_QUERY = "SET_GOHONZON_SEARCH_QUERY";
export const SET_SELECTED_MEMBER_PROFILE = "SET_SELECTED_MEMBER_PROFILE";

// view families action types
export const INITIATE_VIEW_FAMILY_DATA = "INITIATE_VIEW_FAMILY_DATA";
export const SET_VIEW_FAMILY_DATA = "SET_VIEW_FAMILY_DATA";
export const SET_VIEW_FAMILY_DATA_FAIL = "SET_VIEW_FAMILY_DATA_FAIL";
export const SET_FAMILY_SEARCH_QUERY = "SET_FAMILY_SEARCH_QUERY";
export const CLEAR_FAMILY_SEARCH_QUERY = "CLEAR_FAMILY_SEARCH_QUERY";

// view appointment action types
export const INITIATE_VIEW_APPOINTMENT_DATA = "INITIATE_VIEW_APPOINTMENT_DATA";
export const SEARCH_MEMBERS_FOR_APPLY_APPOINTMENT =
  "SEARCH_MEMBERS_FOR_APPLY_APPOINTMENT";
export const INITIATE_APPOINTMENT_APPLICATIONS =
  "INITIATE_APPOINTMENT_APPLICATIONS";
export const SET_MEMBERS_FOR_APPLY_APPOINTMENT =
  "SET_MEMBERS_FOR_APPLY_APPOINTMENT";
export const SET_MEMBERS_FOR_APPOINTMENT_TRACKING =
  "SET_MEMBERS_FOR_APPOINTMENT_TRACKING";
export const SET_MEMBERS_FOR_APPOINTMENT_TRACKING_FAIL =
  "SET_MEMBERS_FOR_APPOINTMENT_TRACKING_FAIL";
export const SET_MEMBERS_FOR_APPLY_APPOINTMENT_FAIL =
  "SET_MEMBERS_FOR_APPLY_APPOINTMENT_FAIL";
export const SET_MEMBER_FOR_APPLY_APPOINTMENT =
  "SET_MEMBER_FOR_APPLY_APPOINTMENT";
export const SET_MEMBER_FOR_TRACKING_APPOINTMENT =
  "SET_MEMBER_FOR_TRACKING_APPOINTMENT";
export const SET_POSITION_ID = "SET_POSITION_ID";
export const SET_APPOINTMENT_FORM_STATE = "SET_APPOINTMENT_FORM_STATE";
export const SET_RESET_APPOINTMENT_STATE = "SET_RESET_APPOINTMENT_STATE";
export const SET_VIEW_APPOINTMENT_DATA = "SET_VIEW_APPOINTMENT_DATA";
export const SET_VIEW_APPOINTMENT_DATA_FAIL = "SET_VIEW_APPOINTMENT_DATA_FAIL";
export const SET_APPOINTMENT_SEARCH_QUERY = "SET_APPOINTMENT_SEARCH_QUERY";
export const SET_APPOINTMENT_TYPE_FOR_APPLY = "SET_APPOINTMENT_TYPE_FOR_APPLY";

export const INITIATE_APPOINTMENT_APPLICATIONS_TRACKING =
  "INITIATE_APPOINTMENT_APPLICATIONS_TRACKING";

// view announcement Cycle actionTypes

export const INITIATE_VIEW_ANNOUNCEMENT_CYCLE_DATA =
  "INITIATE_VIEW_ANNOUNCEMENT_CYCLE_DATA";
export const SET_VIEW_ANNOUNCEMENT_CYCLE_DATA =
  "SET_VIEW_ANNOUNCEMENT_CYCLE_DATA";
export const SET_VIEW_ANNOUNCEMENT_CYCLE_FAIL =
  "SET_VIEW_ANNOUNCEMENT_CYCLE_FAIL";
export const SET_SELECTED_ANNOUNCEMENT_CYCLE =
  "SET_SELECTED_ANNOUNCEMENT_CYCLE";
// SPLIT
export const SET_SPLIT_SEARCH_RESULT = "SET_SPLIT_SEARCH_RESULT";
export const RESET_SPLIT_SEARCH_RESULT = "RESET_SPLIT_SEARCH_RESULT";
export const SET_SPLIT_LEVEL = "SET_SPLIT_LEVEL";
export const SET_SPLIT_NEXT_CHIEF_ID = "SET_SPLIT_NEXT_CHIEF_ID";
